var _image, _path, _title, _path2, _title2, _path3, _title3, _path4, _title4, _path5, _title5, _path6, _title6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonutPileSearchAndFindCodesweetly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1500 1088",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "donut-pile-search-and-find",
    className: "search-and-find-image",
    width: "1500px",
    height: "1088px",
    xlinkHref: "https://cdna.artstation.com/p/assets/images/images/035/547/472/large/rory-adams-blueberrybamf-donut-pile-colored.jpg?1615253622"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "carrot-outline",
    className: "search-and-find-image",
    "data-item-name": "Carrot",
    d: "M1450.01,345.748L1426.98,305.859C1426.98,305.859 1424.77,300.592 1429.66,302.883L1456.66,327.805L1463.16,336.907L1464.46,338.579C1464.46,338.579 1472.38,344.59 1474.31,347.116C1474.31,347.116 1478.77,354.843 1479.27,356.032C1479.27,356.032 1480.85,360.837 1479.57,361.233C1479.57,361.233 1477.83,361.927 1476.99,361.382C1476.99,361.382 1475.6,364.924 1471.74,364.032L1467.48,359.921L1457.72,348.528L1455.64,347.19L1450.01,345.748Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,758.434,-71.9625)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "carrot-found",
    x: "654.795px",
    y: "420.229px",
    style: {
      fontFamily: "'SegoeUIEmoji', 'Segoe UI Emoji', sans-serif",
      fontSize: "58.333px",
      fill: "rgb(0,128,0)",
      stroke: "white",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 2
    }
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Carrot found!")), "\u2714")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "pack-of-fries-outline",
    className: "search-and-find-image",
    "data-item-name": "Pack of fries",
    d: "M1400.7,88.569C1400.7,88.569 1403.51,81.635 1405.1,81.139L1406.23,79.158L1402.07,69.3L1405.79,67.369L1408.91,71.926C1408.91,71.926 1409.16,61.796 1413.02,60.211C1413.02,60.211 1415.15,59.815 1416.49,60.855L1420.1,56.743L1425.01,56.099C1425.01,56.099 1427.34,56.298 1428.08,57.982L1428.18,61.845L1430.85,61.35L1432.44,63.53L1432.59,65.561L1430.73,69.232L1433.59,70.083L1434.75,72.831L1435.14,76.894L1438.39,84.015L1433.59,85.795L1426.48,90.206L1425.63,92.857L1425.98,100.089L1420.83,102.219C1420.83,102.219 1419.74,92.46 1407.85,89.736L1400.7,88.569Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,730.158,-305.039)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "pack-of-fries-found",
    x: "654.795px",
    y: "420.229px",
    style: {
      fontFamily: "'SegoeUIEmoji', 'Segoe UI Emoji', sans-serif",
      fontSize: "58.333px",
      fill: "rgb(0,128,0)",
      stroke: "white",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 2
    }
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Pack of fries found!")), "\u2714")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "hamburger-outline",
    className: "search-and-find-image",
    "data-item-name": "Hamburger",
    d: "M1114.36,879.317L1115.99,874.41L1117.83,872.863L1117.54,868.219C1117.54,868.219 1109.32,846.112 1134.28,836.147C1134.28,836.147 1147.63,832.277 1160.3,837.405L1164.66,835.566L1168.91,838.856C1168.91,838.856 1175.69,837.018 1175.88,839.63C1175.88,839.63 1179.17,842.048 1170.17,843.5L1169.69,845.144C1169.69,845.144 1174.33,844.757 1175.98,847.273C1175.98,847.273 1178.3,850.949 1175.88,851.82L1172.4,852.787L1172.88,856.851L1168.53,860.334C1168.53,860.334 1165.91,864.494 1169.88,864.107C1169.88,864.107 1174.24,868.751 1165.72,867.977L1163.5,870.299L1160.3,872.717L1160.3,875.233L1154.13,878.939L1153.29,880.512L1147,879.786L1145.3,884.006L1136.5,884.006L1135.91,883.034L1132.69,884.006L1124.85,884.006L1121.99,880.144L1118.74,881.615L1114.79,881.615L1114.36,879.317Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,457.016,450.84)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "hamburger-found",
    x: "654.795px",
    y: "420.229px",
    style: {
      fontFamily: "'SegoeUIEmoji', 'Segoe UI Emoji', sans-serif",
      fontSize: "58.333px",
      fill: "rgb(0,128,0)",
      stroke: "white",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 2
    }
  }, _title3 || (_title3 = /*#__PURE__*/React.createElement("title", null, "Hamburger found!")), "\u2714")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "pizza-outline",
    className: "search-and-find-image",
    "data-item-name": "Pizza",
    d: "M628.657,397.562C628.657,397.562 626.118,365.46 664.847,354.031C664.847,354.031 688.973,348.529 711.195,365.46C711.195,365.46 711.861,375.673 713.269,377.623C713.269,377.623 700.915,379.244 698.206,390.757C698.206,390.757 697.529,408.23 703.353,415.679C703.353,415.679 697.664,419.472 696.445,421.097C696.445,421.097 685.88,409.042 678.431,409.72C678.431,409.72 661.365,404.302 649.852,416.898C649.852,416.898 650.122,393.601 630.889,403.083C630.889,403.083 631.301,396.918 628.657,397.562Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.14608,-15.0412)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "pizza-found",
    x: "654.795px",
    y: "420.229px",
    style: {
      fontFamily: "'SegoeUIEmoji', 'Segoe UI Emoji', sans-serif",
      fontSize: "58.333px",
      fill: "rgb(0,128,0)",
      stroke: "white",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 2
    }
  }, _title4 || (_title4 = /*#__PURE__*/React.createElement("title", null, "Pizza found!")), "\u2714")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "american-football-outline",
    className: "search-and-find-image",
    "data-item-name": "American football",
    d: "M451.659,807.035C451.659,807.035 416.815,805.403 408.107,817.133C408.107,817.133 405.81,827.776 413.549,833.822C413.549,833.822 423.708,845.19 438.704,848.576C438.704,848.576 443.662,844.344 447.29,844.948C447.29,844.948 442.936,831.525 448.62,829.348C448.62,829.348 449.862,828.56 452.667,828.754C452.667,828.754 451.603,822.562 456.44,822.078C456.44,822.078 449.877,811.826 451.659,807.035Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-249.553,436.108)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "american-football-found",
    x: "654.795px",
    y: "420.229px",
    style: {
      fontFamily: "'SegoeUIEmoji', 'Segoe UI Emoji', sans-serif",
      fontSize: "58.333px",
      fill: "rgb(0,128,0)",
      stroke: "white",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 2
    }
  }, _title5 || (_title5 = /*#__PURE__*/React.createElement("title", null, "American football found!")), "\u2714")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "pineapple-outline",
    className: "search-and-find-image",
    "data-item-name": "Pineapple",
    d: "M273.441,219.83L279.053,215.152L283.387,208.109C283.387,208.109 293.681,192.088 319.764,192.397L320.512,192.459L320.056,190.684L316.199,183.784L316.353,181.694L317.937,182.145L318.254,177.866L320.355,178.301L323.327,181.313L324.793,180.877L325.271,172.788C325.271,172.788 326.881,171.549 327.934,173.221L328.739,175.45L330.101,175.326L330.163,171.921L332.392,171.24L332.64,167.308L333.754,166.441L334.126,158.268C334.126,158.268 337.345,162.602 337.841,167.865L338.274,174.738L339.079,174.366C339.079,174.366 344.095,164.955 343.042,163.159C343.042,163.159 345.147,172.942 343.847,176.286L347.159,175.819C347.159,175.819 358.84,168.655 366.022,171.937L358.716,176.086L351.719,180.048C351.719,180.048 349.614,181.287 352.586,182.773L357.911,184.63L360.348,187.09C360.348,187.09 352.992,187.966 350.912,189.798L349.772,190.888C349.772,190.888 348.782,192.424 353.141,192.325C353.141,192.325 355.073,193.167 355.221,194.405L355.122,195.297L349.772,195.148L343.382,196.245L340.361,197.699L340.091,199.551C340.091,199.551 344.735,199.551 345.199,202.106L336.299,202.183L330.494,203.653C330.494,203.653 334.209,211.2 332.274,217.082L330.837,220.443L327.865,223.365L321.525,222.573C321.525,222.573 318.652,222.176 315.085,223.811L310.033,227.972L309.537,230.201C309.537,230.201 290.528,225.869 278.392,236.079C278.392,236.079 271.751,229.58 273.441,219.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-366.319,-193.569)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "pineapple-found",
    x: "654.795px",
    y: "420.229px",
    style: {
      fontFamily: "'SegoeUIEmoji', 'Segoe UI Emoji', sans-serif",
      fontSize: "58.333px",
      fill: "rgb(0,128,0)",
      stroke: "white",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 2
    }
  }, _title6 || (_title6 = /*#__PURE__*/React.createElement("title", null, "Pineapple found!")), "\u2714")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonutPileSearchAndFindCodesweetly);
export default __webpack_public_path__ + "static/media/donut-pile-search-and-find-codesweetly.c9ad03b61583c188b01e14b19e58bc63.svg";
export { ForwardRef as ReactComponent };